module.exports = __webpack_public_path__ + "img/beast_banner.d1f6e2b5.png";